var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9096AA",
    d: "M10 1.667A8.336 8.336 0 001.667 10c0 4.6 3.733 8.333 8.333 8.333S18.333 14.6 18.333 10 14.6 1.667 10 1.667zM10.833 15a.833.833 0 01-1.667 0 .833.833 0 011.667 0zm1.725-5.625l-.75.767c-.416.425-.716.808-.866 1.408a3.496 3.496 0 00-.082.45c-.031.275-.25.5-.527.5h-.75a.417.417 0 01-.416-.417 3.331 3.331 0 01.975-2.358l1.033-1.05c.383-.367.567-.917.458-1.5A1.659 1.659 0 0010.475 5.9a1.68 1.68 0 00-2.058 1.058c-.1.309-.359.542-.684.542h-.25a.722.722 0 01-.683-.933 3.34 3.34 0 012.692-2.359c1.266-.2 2.475.459 3.225 1.5.983 1.359.691 2.817-.159 3.667z",
    opacity: 0.7
  })));
}
export default SvgQuestion;